var map = {
	"./2020-SFWSC-Silver.png": "add5",
	"./TA-2021-BOP-Silver-RGB-400.png": "2918",
	"./amm-oro.png": "eae4",
	"./bruxelles-mexico-oro-2018.png": "3e8e",
	"./bruxelles-oro-2019.png": "a55e",
	"./cmb2020-gold-medal.png": "689b",
	"./gran_oro-2021.png": "b06e",
	"./london-spirits-2022.png": "34a4",
	"./medalla_gran_oro_2020.png": "9ffb",
	"./medalla_oro_2021.png": "7799",
	"./mexico-plata-bruxelles-2022.png": "227e",
	"./plata_2022_v2.png": "206d",
	"./proof_awards_gold.png": "cd7f",
	"./silver-medal-2024.png": "80e3",
	"./ssel2018-gold-medal.png": "407a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f448";